module.exports = __webpack_public_path__ + "img/map.2251b62c.svg";